export default __webpack_public_path__ + "static/media/gabriel.13349bb7.jpeg";